import { useState } from 'react';
import { updateFeed, feedFilters } from '@/mocks/home';

export default function UpdateFeed() {
  const [active, setActive] = useState('全部');
  const list = active === '全部' ? updateFeed : updateFeed.filter((item) => item.filter === active);

  return (
    <section id="feed" className="bg-background-100 py-10 md:py-16 border-b border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-5">
          <div>
            <span className="text-xs font-label tracking-[0.2em] text-primary-600 uppercase">Live Feed</span>
            <h2 className="mt-1.5 font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新更新</h2>
            <p className="mt-1.5 text-sm text-foreground-500">每条都带一句摘要，点进事件页看完整脉络与多方说法</p>
          </div>
          <span className="text-xs text-foreground-500 whitespace-nowrap self-start md:self-auto">
            共 {list.length} 条 · 每分钟刷新
          </span>
        </div>

        <div className="flex flex-wrap gap-2 mb-6">
          {feedFilters.map((filter) => {
            const isActive = filter === active;
            return (
              <button
                key={filter}
                type="button"
                onClick={() => setActive(filter)}
                className={
                  isActive
                    ? 'h-8 px-4 rounded-full bg-primary-500 text-background-50 text-sm cursor-pointer whitespace-nowrap transition-colors'
                    : 'h-8 px-4 rounded-full bg-background-50 border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 cursor-pointer whitespace-nowrap transition-colors'
                }
              >
                {filter}
              </button>
            );
          })}
        </div>

        {list.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-50 py-14 text-center">
            <div className="w-12 h-12 mx-auto rounded-full bg-background-200 flex items-center justify-center">
              <i className="ri-inbox-line text-xl text-foreground-500"></i>
            </div>
            <p className="mt-3 text-sm text-foreground-500">该分类暂时还没有新条目，换个筛选看看</p>
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            {list.map((item) => (
              <article
                key={item.title}
                className="group flex flex-col sm:flex-row gap-4 rounded-lg border border-background-200 bg-background-50 p-3 md:p-4 hover:border-primary-300 transition-colors"
              >
                <div className="w-full sm:w-44 md:w-52 h-40 sm:h-28 rounded-md overflow-hidden shrink-0 border border-background-200">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} 糖心小桃爆料整理`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1 flex flex-col">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {item.time}
                    </span>
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800">{item.filter}</span>
                  </div>
                  <h3 className="mt-2 text-base md:text-lg font-medium leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.summary}</p>
                  <div className="mt-auto pt-3 flex items-center justify-between gap-3">
                    <div className="flex flex-wrap gap-2">
                      {item.tags.map((tag) => (
                        <span key={tag} className="px-2 py-0.5 rounded-full bg-background-100 border border-background-200 text-[11px] text-foreground-600">
                          {tag}
                        </span>
                      ))}
                    </div>
                    <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-label whitespace-nowrap shrink-0">
                      <i className="ri-fire-fill"></i>
                      {item.heat}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}